<igx-input-group>
  @if (mostrarChkInicio) {
    <igx-prefix>
      <button [title]="textToolTip | translate" igxButton="fab" igxRipple (click)="cambiarBusquedaInicio()">
        <igx-icon family="edicion" [name]="chkBuscarInicio ?  'iniciar_con' : 'contiene'"></igx-icon>
      </button>
    </igx-prefix>
  }
  <label igxLabel>{{ descripcionLabel | translate}}</label>
  <input #input igxInput type="text" (keyup.enter)="onEnterBusPalabra($event.target.value)" (keydown)="stopPropagationPegado($event)"
    [igxTextSelection]="true"/>
  @if (input.value || input.value === '0') {
    <igx-suffix (click)="onClearInput(input)">
      <button title="{{ 'TOOLTIPS.LIMPIAR_FILTRO' | translate }}" igxIconButton="contained" igxRipple>
        <igx-icon>clear</igx-icon>
      </button>
    </igx-suffix>
  }
</igx-input-group>
